import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrmServiceService } from '../../../service/crm-service.service';

@Component({
  selector: 'app-create-qr-coupon',
  templateUrl: './create-qr-coupon.component.html',
  styleUrls: ['./create-qr-coupon.component.scss'],
})
export class CreateQrCouponComponent {
  btnLoader = false;
  dateError = false;
  tagInput = '';
  generationMethod: string = 'AUTO_GENERATED';
  status: boolean = true;
  today: string = new Date().toISOString().split('T')[0];
  minDigitLength = 0;
  maxDigitLength = 0;
  minDigits: boolean = false
  readonly EXTRA_DIGITS = 3;
  couponPurpose: any = ""

  constructor(
    public dialogRef: MatDialogRef<CreateQrCouponComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private crmService: CrmServiceService,
  ) {
    console.log(data)
  }

  createPayload: any = {
    id: null,
    couponName: '',
    couponPrefix: '',
    couponSuffix: '',
    descLine1: '',
    descLine2: '',
    locationDetails: '',
    tags: [],
    digitlength: 0,
    couponsQuantity: 0,
    businessId: localStorage.getItem('businessId'),
    effectiveDate: '',
    expiryDate: '',
    active: this.status,
    termsAndConditions: '',
    couponValueType: "PERCENTAGE",
    maxRedeemableAmount: "",
    lowStockAlertNotification: false,
    minOrderValue: "",
    couponValue: "",
    lowAlertCount: 0
  };

  ngOnInit(): void {
    if (this.data?.coupon) {
      const coupon = this.data.coupon;

      this.createPayload = {
        id: coupon.id,
        couponName: coupon.couponName || '',
        couponPrefix: coupon.couponPrefix || '',
        descLine1: coupon.desc || '',
        locationDetails: coupon.location || '',
        tags: [...(coupon.tags || [])],
        businessId: localStorage.getItem('businessId'),
        effectiveDate: coupon.effectiveDate || '',
        expiryDate: coupon.expiryDate || '',
        termsAndConditions: this.createPayload.termsAndConditions?.trim() || ''
      };
    }
    // if (this.data?.type === 'crmCoupons') {
    //   this.couponPurpose = 'CAMPAIGN'
    // }
    // else if (this.data?.type === 'referralCoupons') {
    //   this.couponPurpose = 'REFERRAL_PROGRAM'
    // }
    // else {
    //   this.couponPurpose = null
    // }
  }

  close() {
    this.dialogRef.close();
  }

  addCoupon() {
    // const trimmedName = this.createPayload.couponName?.trim();

    // if (!trimmedName) {
    //   return; // Stop API call
    // }
    const name = this.createPayload.couponName?.trim();
    const prefix = this.createPayload.couponPrefix?.trim();

    if (!name) return;
    if (!prefix) return;

    if (!/^[A-Z0-9]+$/.test(prefix)) {
      return;
    }

    if (
      !this.createPayload.couponsQuantity ||
      this.createPayload.couponsQuantity <= 0
    ) {
      return;
    }

    if (
      !this.createPayload.digitlength ||
      this.createPayload.digitlength < this.minDigitLength
    ) {
      return;
    }
    this.btnLoader = true;
    const payload: any = {
      couponName: this.createPayload.couponName?.trim() || '',
      couponPrefix: this.createPayload.couponPrefix || '',
      couponSuffix: this.createPayload.couponSuffix || '',
      descLine1: this.createPayload.descLine1 || '',
      descLine2: this.createPayload.descLine2 || '',
      businessId: this.createPayload.businessId || '',
      effectiveDate:
        this.createPayload.effectiveDate === ''
          ? ''
          : new Date(this?.createPayload?.effectiveDate)?.toISOString(),
      expiryDate:
        this.createPayload?.expiryDate === ''
          ? ''
          : new Date(this?.createPayload?.expiryDate)?.toISOString(),
      digitLength: this.createPayload.digitlength || '',
      couponsQuantity: this.createPayload.couponsQuantity || '',
      active: this.createPayload.active || '',
      termsAndConditions: this.createPayload.termsAndConditions?.trim() || '',
      couponPurpose: this.couponPurpose,
      couponValueType: this.couponPurpose === 'REFERRAL_PROGRAM' ? this.createPayload.couponValueType : "",
      maxRedeemableAmount: this.couponPurpose === 'REFERRAL_PROGRAM' ? this.createPayload.maxRedeemableAmount : "",
      lowStockAlertNotification: this.createPayload.lowStockAlertNotification || false,
      minOrderValue: this.couponPurpose === 'REFERRAL_PROGRAM' ? this.createPayload.minOrderValue : "",
      lowAlertCount: this.createPayload.lowAlertCount || 0,
      couponValue: this.createPayload.couponValue || ''
    };

    // console.log(payload);
    // return
    this.crmService.createCoupon(payload).subscribe({
      next: (res: any) => {
        this.btnLoader = false;
        const createdForm = res?.data || res?.data?.data;
        const messageData = {
          type: 'SIMPO_COUPON_CREATED',
          payload: { id: createdForm.id, name: createdForm.formName },
        };

        // This hits the Main Angular Wrapper
        window.parent.postMessage(messageData, '*');

        // Also hit the current window just in case
        window.postMessage(messageData, '*');
        this.dialogRef.close(res);
      },
      error: () => {
        this.btnLoader = false;
      },
    });
  }

  addTag(event: Event) {
    const keyboardEvent = event as KeyboardEvent;

    // Handle Enter or Comma
    if (keyboardEvent.key !== 'Enter' && keyboardEvent.key !== ',') {
      return;
    }

    keyboardEvent.preventDefault();

    const value = this.tagInput.replace(',', '').trim();
    if (!value) return;

    if (!this.createPayload.tags.includes(value)) {
      this.createPayload.tags.push(value);
    }

    this.tagInput = '';
  }

  removeTag(index: number) {
    this.createPayload.tags.splice(index, 1);
  }

  onStartDateChange(date: string) {
    if (this.createPayload.expiryDate && this.createPayload.expiryDate < date) {
      this.createPayload.expiryDate = '';
    }
  }

  onPrefixChange(value: string) {
    if (!value) {
      this.createPayload.couponPrefix = '';
      return;
    }

    // Remove spaces and special characters
    const cleaned = value.replace(/[^a-zA-Z0-9]/g, '');

    // Convert to uppercase
    this.createPayload.couponPrefix = cleaned.toUpperCase();

    this.updateMinDigitLength();
  }

  updateMinDigitLength() {
    const prefixLength = this.createPayload.couponPrefix?.length || 0;
    const suffixLength = this.createPayload.couponSuffix?.length || 0;
    const count = this.createPayload.couponsQuantity || 0;

    const countDigits = this.getCountDigits(count);

    if (prefixLength > 0 || suffixLength > 0 || count > 0) {
      this.minDigitLength = prefixLength + suffixLength + countDigits;
      this.maxDigitLength = this.minDigitLength + 3;
    } else {
      this.minDigitLength = 0;
      this.maxDigitLength = 0;
    }

    // Validate entered digit length
    const digitLength = this.createPayload.digitlength;

    if (
      digitLength &&
      (digitLength < this.minDigitLength ||
        digitLength > this.maxDigitLength)
    ) {
      this.minDigits = true;
    } else {
      this.minDigits = false;
    }
  }


  private getCountDigits(count: number): number {
    if (!count || count <= 0) return 0;
    return count.toString().length;
  }
}
